import { render, staticRenderFns } from "./template.vue?vue&type=template&id=5dd679f5&scoped=true&"
import script from "@/Views/Global/PasswordReset/component.ts?vue&type=script&lang=ts&"
export * from "@/Views/Global/PasswordReset/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Views/Global/PasswordReset/style.scss?vue&type=style&index=0&id=5dd679f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd679f5",
  null
  
)

export default component.exports